import script from "./DominanceLineChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DominanceLineChart.vue?vue&type=script&setup=true&lang=js"

import "./DominanceLineChart.vue?vue&type=style&index=0&id=8a23d756&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a23d756"]])

export default __exports__